/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.resource[_ngcontent-%COMP%]{padding-bottom:20vw}.resource-img[_ngcontent-%COMP%]{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;background:50%/contain no-repeat;border:15px solid transparent}.resource-title[_ngcontent-%COMP%]{background:#43a047;color:#fff;position:absolute;bottom:0;left:15px;right:15px;text-align:center;padding:.275rem}.is-scrollable[_ngcontent-%COMP%]{max-height:500px;position:relative}"];
export { styles as styles };
